export default __webpack_public_path__ + "static/media/notfound.8d01b701.svg";